import { __ } from '@wordpress/i18n';
import { useBlockProps, RichText, MediaUpload, InspectorControls, URLInput } from '@wordpress/blockEditor';
import { PanelBody, ToggleControl, ColorPalette, BaseControl, Button, RangeControl, TextControl } from '@wordpress/components';
import { useSelect } from '@wordpress/data';

export default function Edit({ attributes, setAttributes }) {
    const { id_titre_1Texte, id_titre_1CouleurTexte, id_titre_1Opacite, id_titre_1Afficher, id_sous_titre_1Texte, id_sous_titre_1CouleurTexte, id_sous_titre_1Opacite, id_sous_titre_1Afficher, id_paragraphe_1Texte, id_paragraphe_1CouleurTexte, id_paragraphe_1Opacite, id_paragraphe_1Afficher, id_row_1_bloc_image_1Id, id_row_1_bloc_image_1Alt, id_row_1_bloc_image_1Opacite, id_row_1_bloc_image_1Afficher, id_row_1_bloc_texte_1_titre_1Texte, id_row_1_bloc_texte_1_titre_1CouleurTexte, id_row_1_bloc_texte_1_titre_1Opacite, id_row_1_bloc_texte_1_titre_1Afficher, id_row_1_bloc_texte_1_texte_1Texte, id_row_1_bloc_texte_1_texte_1CouleurTexte, id_row_1_bloc_texte_1_texte_1Opacite, id_row_1_bloc_texte_1_texte_1Afficher, id_row_1_bloc_image_2Id, id_row_1_bloc_image_2Alt, id_row_1_bloc_image_2Opacite, id_row_1_bloc_image_2Afficher, id_row_1_bloc_texte_2_titre_1Texte, id_row_1_bloc_texte_2_titre_1CouleurTexte, id_row_1_bloc_texte_2_titre_1Opacite, id_row_1_bloc_texte_2_titre_1Afficher, id_row_1_bloc_texte_2_texte_1Texte, id_row_1_bloc_texte_2_texte_1CouleurTexte, id_row_1_bloc_texte_2_texte_1Opacite, id_row_1_bloc_texte_2_texte_1Afficher, id_row_2_bloc_texte_1_titre_1Texte, id_row_2_bloc_texte_1_titre_1CouleurTexte, id_row_2_bloc_texte_1_titre_1Opacite, id_row_2_bloc_texte_1_titre_1Afficher, id_row_2_bloc_texte_1_texte_1Texte, id_row_2_bloc_texte_1_texte_1CouleurTexte, id_row_2_bloc_texte_1_texte_1Opacite, id_row_2_bloc_texte_1_texte_1Afficher, id_row_2_bloc_image_1Id, id_row_2_bloc_image_1Alt, id_row_2_bloc_image_1Opacite, id_row_2_bloc_image_1Afficher, id_row_2_bloc_texte_2_titre_1Texte, id_row_2_bloc_texte_2_titre_1CouleurTexte, id_row_2_bloc_texte_2_titre_1Opacite, id_row_2_bloc_texte_2_titre_1Afficher, id_row_2_bloc_texte_2_texte_1Texte, id_row_2_bloc_texte_2_texte_1CouleurTexte, id_row_2_bloc_texte_2_texte_1Opacite, id_row_2_bloc_texte_2_texte_1Afficher, id_row_2_bloc_image_2Id, id_row_2_bloc_image_2Alt, id_row_2_bloc_image_2Opacite, id_row_2_bloc_image_2Afficher, id_row_3_bloc_image_1Id, id_row_3_bloc_image_1Alt, id_row_3_bloc_image_1Opacite, id_row_3_bloc_image_1Afficher, id_row_3_bloc_texte_1_titre_1Texte, id_row_3_bloc_texte_1_titre_1CouleurTexte, id_row_3_bloc_texte_1_titre_1Opacite, id_row_3_bloc_texte_1_titre_1Afficher, id_row_3_bloc_texte_1_texte_1Texte, id_row_3_bloc_texte_1_texte_1CouleurTexte, id_row_3_bloc_texte_1_texte_1Opacite, id_row_3_bloc_texte_1_texte_1Afficher, id_row_3_bloc_image_2Id, id_row_3_bloc_image_2Alt, id_row_3_bloc_image_2Opacite, id_row_3_bloc_image_2Afficher, id_row_3_bloc_texte_2_titre_1Texte, id_row_3_bloc_texte_2_titre_1CouleurTexte, id_row_3_bloc_texte_2_titre_1Opacite, id_row_3_bloc_texte_2_titre_1Afficher, id_row_3_bloc_texte_2_texte_1Texte, id_row_3_bloc_texte_2_texte_1CouleurTexte, id_row_3_bloc_texte_2_texte_1Opacite, id_row_3_bloc_texte_2_texte_1Afficher, blocCouleurFond, blocCouleurBordure, blocImageFondId, animCode } = attributes;

    // Récupération dynamique et réactive des URLs avec useSelect
    const { imageUrl, id_row_1_bloc_image_1ImageUrl, id_row_1_bloc_image_2ImageUrl, id_row_2_bloc_image_1ImageUrl, id_row_2_bloc_image_2ImageUrl, id_row_3_bloc_image_1ImageUrl, id_row_3_bloc_image_2ImageUrl } = useSelect( ( select ) => {
        const media = select( 'core' );
        return {
            imageUrl: blocImageFondId ? media.getMedia( blocImageFondId )?.source_url : null,
            id_row_1_bloc_image_1ImageUrl: id_row_1_bloc_image_1Id ? media.getMedia( id_row_1_bloc_image_1Id )?.source_url : null,
            id_row_1_bloc_image_2ImageUrl: id_row_1_bloc_image_2Id ? media.getMedia( id_row_1_bloc_image_2Id )?.source_url : null,
            id_row_2_bloc_image_1ImageUrl: id_row_2_bloc_image_1Id ? media.getMedia( id_row_2_bloc_image_1Id )?.source_url : null,
            id_row_2_bloc_image_2ImageUrl: id_row_2_bloc_image_2Id ? media.getMedia( id_row_2_bloc_image_2Id )?.source_url : null,
            id_row_3_bloc_image_1ImageUrl: id_row_3_bloc_image_1Id ? media.getMedia( id_row_3_bloc_image_1Id )?.source_url : null,
            id_row_3_bloc_image_2ImageUrl: id_row_3_bloc_image_2Id ? media.getMedia( id_row_3_bloc_image_2Id )?.source_url : null
        };
    }, [ blocImageFondId, id_row_1_bloc_image_1Id, id_row_1_bloc_image_2Id, id_row_2_bloc_image_1Id, id_row_2_bloc_image_2Id, id_row_3_bloc_image_1Id, id_row_3_bloc_image_2Id ] );

    // Construire le style du bloc avec image de fond en priorité
    const blocStyle = imageUrl 
        ? { 
            backgroundImage: `url(${imageUrl})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            borderColor: blocCouleurBordure
        }
        : { 
            backgroundColor: blocCouleurFond, 
            borderColor: blocCouleurBordure 
        };

    const blockProps = useBlockProps({
        style: blocStyle
    });

    return (
        <>
            <style>{``}</style>
            {/* BARRE LATÉRALE (INSPECTOR) */}
            <InspectorControls>

                <PanelBody title="Bloc Principal" initialOpen={true}>
                    <BaseControl label="Image de fond">
                        <MediaUpload
                            onSelect={(media) => setAttributes({ blocImageFondId: media.id })}
                            type="image"
                            value={blocImageFondId}
                            render={({ open }) => (
                                <div>
                                    {imageUrl ? (
                                        <div>
                                            <img src={imageUrl} style={{ maxWidth: '100%', marginBottom: '10px' }} />
                                            <Button 
                                                variant="secondary" 
                                                isDestructive
                                                onClick={() => setAttributes({ blocImageFondId: 0 })}>
                                                Supprimer l'image
                                            </Button>
                                        </div>
                                    ) : (
                                        <Button variant="primary" onClick={open}>
                                            Choisir une image de fond
                                        </Button>
                                    )}
                                </div>
                            )}
                        />
                    </BaseControl>
                    <BaseControl label="Couleur de fond (fallback)" help="Utilisée si aucune image n'est définie">
                        <ColorPalette
                            value={blocCouleurFond}
                            onChange={(val) => setAttributes({ blocCouleurFond: val })}
                        />
                    </BaseControl>
                    <BaseControl label="Couleur de bordure">
                        <ColorPalette
                            value={blocCouleurBordure}
                            onChange={(val) => setAttributes({ blocCouleurBordure: val })}
                        />
                    </BaseControl>
                </PanelBody>
                <PanelBody title="titre-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_titre_1Afficher}
                        onChange={(val) => setAttributes({ id_titre_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_titre_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_titre_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_titre_1Opacite}
                        onChange={(val) => setAttributes({ id_titre_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="sous-titre-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_sous_titre_1Afficher}
                        onChange={(val) => setAttributes({ id_sous_titre_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_sous_titre_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_sous_titre_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_sous_titre_1Opacite}
                        onChange={(val) => setAttributes({ id_sous_titre_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="paragraphe-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_paragraphe_1Afficher}
                        onChange={(val) => setAttributes({ id_paragraphe_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_paragraphe_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_paragraphe_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_paragraphe_1Opacite}
                        onChange={(val) => setAttributes({ id_paragraphe_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="bloc-image-1 (Image)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_row_1_bloc_image_1Afficher}
                        onChange={(val) => setAttributes({ id_row_1_bloc_image_1Afficher: val })}
                    />
                    <BaseControl label="Texte alternatif">
                        <TextControl
                            value={id_row_1_bloc_image_1Alt}
                            onChange={(val) => setAttributes({ id_row_1_bloc_image_1Alt: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_row_1_bloc_image_1Opacite}
                        onChange={(val) => setAttributes({ id_row_1_bloc_image_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="titre-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_row_1_bloc_texte_1_titre_1Afficher}
                        onChange={(val) => setAttributes({ id_row_1_bloc_texte_1_titre_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_row_1_bloc_texte_1_titre_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_row_1_bloc_texte_1_titre_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_row_1_bloc_texte_1_titre_1Opacite}
                        onChange={(val) => setAttributes({ id_row_1_bloc_texte_1_titre_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="texte-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_row_1_bloc_texte_1_texte_1Afficher}
                        onChange={(val) => setAttributes({ id_row_1_bloc_texte_1_texte_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_row_1_bloc_texte_1_texte_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_row_1_bloc_texte_1_texte_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_row_1_bloc_texte_1_texte_1Opacite}
                        onChange={(val) => setAttributes({ id_row_1_bloc_texte_1_texte_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="bloc-image-2 (Image)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_row_1_bloc_image_2Afficher}
                        onChange={(val) => setAttributes({ id_row_1_bloc_image_2Afficher: val })}
                    />
                    <BaseControl label="Texte alternatif">
                        <TextControl
                            value={id_row_1_bloc_image_2Alt}
                            onChange={(val) => setAttributes({ id_row_1_bloc_image_2Alt: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_row_1_bloc_image_2Opacite}
                        onChange={(val) => setAttributes({ id_row_1_bloc_image_2Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="titre-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_row_1_bloc_texte_2_titre_1Afficher}
                        onChange={(val) => setAttributes({ id_row_1_bloc_texte_2_titre_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_row_1_bloc_texte_2_titre_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_row_1_bloc_texte_2_titre_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_row_1_bloc_texte_2_titre_1Opacite}
                        onChange={(val) => setAttributes({ id_row_1_bloc_texte_2_titre_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="texte-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_row_1_bloc_texte_2_texte_1Afficher}
                        onChange={(val) => setAttributes({ id_row_1_bloc_texte_2_texte_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_row_1_bloc_texte_2_texte_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_row_1_bloc_texte_2_texte_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_row_1_bloc_texte_2_texte_1Opacite}
                        onChange={(val) => setAttributes({ id_row_1_bloc_texte_2_texte_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="titre-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_row_2_bloc_texte_1_titre_1Afficher}
                        onChange={(val) => setAttributes({ id_row_2_bloc_texte_1_titre_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_row_2_bloc_texte_1_titre_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_row_2_bloc_texte_1_titre_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_row_2_bloc_texte_1_titre_1Opacite}
                        onChange={(val) => setAttributes({ id_row_2_bloc_texte_1_titre_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="texte-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_row_2_bloc_texte_1_texte_1Afficher}
                        onChange={(val) => setAttributes({ id_row_2_bloc_texte_1_texte_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_row_2_bloc_texte_1_texte_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_row_2_bloc_texte_1_texte_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_row_2_bloc_texte_1_texte_1Opacite}
                        onChange={(val) => setAttributes({ id_row_2_bloc_texte_1_texte_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="bloc-image-1 (Image)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_row_2_bloc_image_1Afficher}
                        onChange={(val) => setAttributes({ id_row_2_bloc_image_1Afficher: val })}
                    />
                    <BaseControl label="Texte alternatif">
                        <TextControl
                            value={id_row_2_bloc_image_1Alt}
                            onChange={(val) => setAttributes({ id_row_2_bloc_image_1Alt: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_row_2_bloc_image_1Opacite}
                        onChange={(val) => setAttributes({ id_row_2_bloc_image_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="titre-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_row_2_bloc_texte_2_titre_1Afficher}
                        onChange={(val) => setAttributes({ id_row_2_bloc_texte_2_titre_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_row_2_bloc_texte_2_titre_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_row_2_bloc_texte_2_titre_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_row_2_bloc_texte_2_titre_1Opacite}
                        onChange={(val) => setAttributes({ id_row_2_bloc_texte_2_titre_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="texte-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_row_2_bloc_texte_2_texte_1Afficher}
                        onChange={(val) => setAttributes({ id_row_2_bloc_texte_2_texte_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_row_2_bloc_texte_2_texte_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_row_2_bloc_texte_2_texte_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_row_2_bloc_texte_2_texte_1Opacite}
                        onChange={(val) => setAttributes({ id_row_2_bloc_texte_2_texte_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="bloc-image-2 (Image)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_row_2_bloc_image_2Afficher}
                        onChange={(val) => setAttributes({ id_row_2_bloc_image_2Afficher: val })}
                    />
                    <BaseControl label="Texte alternatif">
                        <TextControl
                            value={id_row_2_bloc_image_2Alt}
                            onChange={(val) => setAttributes({ id_row_2_bloc_image_2Alt: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_row_2_bloc_image_2Opacite}
                        onChange={(val) => setAttributes({ id_row_2_bloc_image_2Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="bloc-image-1 (Image)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_row_3_bloc_image_1Afficher}
                        onChange={(val) => setAttributes({ id_row_3_bloc_image_1Afficher: val })}
                    />
                    <BaseControl label="Texte alternatif">
                        <TextControl
                            value={id_row_3_bloc_image_1Alt}
                            onChange={(val) => setAttributes({ id_row_3_bloc_image_1Alt: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_row_3_bloc_image_1Opacite}
                        onChange={(val) => setAttributes({ id_row_3_bloc_image_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="titre-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_row_3_bloc_texte_1_titre_1Afficher}
                        onChange={(val) => setAttributes({ id_row_3_bloc_texte_1_titre_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_row_3_bloc_texte_1_titre_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_row_3_bloc_texte_1_titre_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_row_3_bloc_texte_1_titre_1Opacite}
                        onChange={(val) => setAttributes({ id_row_3_bloc_texte_1_titre_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="texte-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_row_3_bloc_texte_1_texte_1Afficher}
                        onChange={(val) => setAttributes({ id_row_3_bloc_texte_1_texte_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_row_3_bloc_texte_1_texte_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_row_3_bloc_texte_1_texte_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_row_3_bloc_texte_1_texte_1Opacite}
                        onChange={(val) => setAttributes({ id_row_3_bloc_texte_1_texte_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="bloc-image-2 (Image)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_row_3_bloc_image_2Afficher}
                        onChange={(val) => setAttributes({ id_row_3_bloc_image_2Afficher: val })}
                    />
                    <BaseControl label="Texte alternatif">
                        <TextControl
                            value={id_row_3_bloc_image_2Alt}
                            onChange={(val) => setAttributes({ id_row_3_bloc_image_2Alt: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_row_3_bloc_image_2Opacite}
                        onChange={(val) => setAttributes({ id_row_3_bloc_image_2Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="titre-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_row_3_bloc_texte_2_titre_1Afficher}
                        onChange={(val) => setAttributes({ id_row_3_bloc_texte_2_titre_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_row_3_bloc_texte_2_titre_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_row_3_bloc_texte_2_titre_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_row_3_bloc_texte_2_titre_1Opacite}
                        onChange={(val) => setAttributes({ id_row_3_bloc_texte_2_titre_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="texte-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_row_3_bloc_texte_2_texte_1Afficher}
                        onChange={(val) => setAttributes({ id_row_3_bloc_texte_2_texte_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_row_3_bloc_texte_2_texte_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_row_3_bloc_texte_2_texte_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_row_3_bloc_texte_2_texte_1Opacite}
                        onChange={(val) => setAttributes({ id_row_3_bloc_texte_2_texte_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="Animations" initialOpen={false}>
                    <BaseControl 
                        label="Code d'animation" 
                        help="JavaScript exécuté">
                        <textarea
                            value={animCode}
                            onChange={(e) => setAttributes({ animCode: e.target.value })}
                            placeholder="Mon animation ici..."
                            rows={8}
                            style={{ width: '100%', fontFamily: 'monospace', fontSize: '12px' }}
                        />
                    </BaseControl>
                </PanelBody>
            </InspectorControls>

            {/* VISUEL PRINCIPAL */}
            <section { ...blockProps }>
                {/* id_bloc */}
                <div id="id_bloc" className="container-fluid">
                    {/* id_titre_1 */}
                    {id_titre_1Afficher && (
                        <RichText 
                            tagName="h1" 
                            className="id_titre_1 " 
                            value={id_titre_1Texte} 
                            onChange={(val) => setAttributes({ id_titre_1Texte: val })} 
                            placeholder="Saisir le texte..." 
                            style={{ color: id_titre_1CouleurTexte, opacity: id_titre_1Opacite }} 
                        />
                    )}
                    {/* end-id_titre_1 */}
                    {/* id_sous_titre_1 */}
                    {id_sous_titre_1Afficher && (
                        <RichText 
                            tagName="h2" 
                            className="id_sous_titre_1 " 
                            value={id_sous_titre_1Texte} 
                            onChange={(val) => setAttributes({ id_sous_titre_1Texte: val })} 
                            placeholder="Saisir le texte..." 
                            style={{ color: id_sous_titre_1CouleurTexte, opacity: id_sous_titre_1Opacite }} 
                        />
                    )}
                    {/* end-id_sous_titre_1 */}
                    {/* id_paragraphe_1 */}
                    {id_paragraphe_1Afficher && (
                        <RichText 
                            tagName="p" 
                            className="id_paragraphe_1 " 
                            value={id_paragraphe_1Texte} 
                            onChange={(val) => setAttributes({ id_paragraphe_1Texte: val })} 
                            placeholder="Saisir le texte..." 
                            style={{ color: id_paragraphe_1CouleurTexte, opacity: id_paragraphe_1Opacite }} 
                        />
                    )}
                    {/* end-id_paragraphe_1 */}
                    {/* id_inner_block */}
                    <div>
                        {/* id_row_1 */}
                        <div className="row g-0">
                            {/* id_row_1_bloc_image_1 */}
                            <div className="col-12 col-md-6 col-lg-3">
                                {id_row_1_bloc_image_1Afficher && (
                                    <MediaUpload
                                        onSelect={(media) => setAttributes({ id_row_1_bloc_image_1Id: media.id, id_row_1_bloc_image_1Alt: media.alt })}
                                        type="image"
                                        value={id_row_1_bloc_image_1Id}
                                        render={({ open }) => (
                                            <div onClick={open} style={{ cursor: 'pointer' }}>
                                                {id_row_1_bloc_image_1ImageUrl ? (
                                                    <img className="id_row_1_bloc_image_1" src={id_row_1_bloc_image_1ImageUrl} alt={id_row_1_bloc_image_1Alt} style={{ opacity: id_row_1_bloc_image_1Opacite }} />
                                                ) : (
                                                    <Button variant="secondary">Ajouter une image</Button>
                                                )}
                                            </div>
                                        )}
                                    />
                                )}
                            </div>
                            {/* end-id_row_1_bloc_image_1 */}
                            {/* id_row_1_bloc_texte_1 */}
                            <div className="col-12 col-md-6 col-lg-3">
                                {/* id_row_1_bloc_texte_1_titre_1 */}
                                {id_row_1_bloc_texte_1_titre_1Afficher && (
                                    <RichText 
                                        tagName="h3" 
                                        className="id_row_1_bloc_texte_1_titre_1 " 
                                        value={id_row_1_bloc_texte_1_titre_1Texte} 
                                        onChange={(val) => setAttributes({ id_row_1_bloc_texte_1_titre_1Texte: val })} 
                                        placeholder="Saisir le texte..." 
                                        style={{ color: id_row_1_bloc_texte_1_titre_1CouleurTexte, opacity: id_row_1_bloc_texte_1_titre_1Opacite }} 
                                    />
                                )}
                                {/* end-id_row_1_bloc_texte_1_titre_1 */}
                                {/* id_row_1_bloc_texte_1_texte_1 */}
                                {id_row_1_bloc_texte_1_texte_1Afficher && (
                                    <RichText 
                                        tagName="p" 
                                        className="id_row_1_bloc_texte_1_texte_1 " 
                                        value={id_row_1_bloc_texte_1_texte_1Texte} 
                                        onChange={(val) => setAttributes({ id_row_1_bloc_texte_1_texte_1Texte: val })} 
                                        placeholder="Saisir le texte..." 
                                        style={{ color: id_row_1_bloc_texte_1_texte_1CouleurTexte, opacity: id_row_1_bloc_texte_1_texte_1Opacite }} 
                                    />
                                )}
                                {/* end-id_row_1_bloc_texte_1_texte_1 */}
                            </div>
                            {/* end-id_row_1_bloc_texte_1 */}
                            {/* id_row_1_bloc_image_2 */}
                            <div className="col-12 col-md-6 col-lg-3">
                                {id_row_1_bloc_image_2Afficher && (
                                    <MediaUpload
                                        onSelect={(media) => setAttributes({ id_row_1_bloc_image_2Id: media.id, id_row_1_bloc_image_2Alt: media.alt })}
                                        type="image"
                                        value={id_row_1_bloc_image_2Id}
                                        render={({ open }) => (
                                            <div onClick={open} style={{ cursor: 'pointer' }}>
                                                {id_row_1_bloc_image_2ImageUrl ? (
                                                    <img className="id_row_1_bloc_image_2" src={id_row_1_bloc_image_2ImageUrl} alt={id_row_1_bloc_image_2Alt} style={{ opacity: id_row_1_bloc_image_2Opacite }} />
                                                ) : (
                                                    <Button variant="secondary">Ajouter une image</Button>
                                                )}
                                            </div>
                                        )}
                                    />
                                )}
                            </div>
                            {/* end-id_row_1_bloc_image_2 */}
                            {/* id_row_1_bloc_texte_2 */}
                            <div className="col-12 col-md-6 col-lg-3">
                                {/* id_row_1_bloc_texte_2_titre_1 */}
                                {id_row_1_bloc_texte_2_titre_1Afficher && (
                                    <RichText 
                                        tagName="h3" 
                                        className="id_row_1_bloc_texte_2_titre_1 " 
                                        value={id_row_1_bloc_texte_2_titre_1Texte} 
                                        onChange={(val) => setAttributes({ id_row_1_bloc_texte_2_titre_1Texte: val })} 
                                        placeholder="Saisir le texte..." 
                                        style={{ color: id_row_1_bloc_texte_2_titre_1CouleurTexte, opacity: id_row_1_bloc_texte_2_titre_1Opacite }} 
                                    />
                                )}
                                {/* end-id_row_1_bloc_texte_2_titre_1 */}
                                {/* id_row_1_bloc_texte_2_texte_1 */}
                                {id_row_1_bloc_texte_2_texte_1Afficher && (
                                    <RichText 
                                        tagName="p" 
                                        className="id_row_1_bloc_texte_2_texte_1 " 
                                        value={id_row_1_bloc_texte_2_texte_1Texte} 
                                        onChange={(val) => setAttributes({ id_row_1_bloc_texte_2_texte_1Texte: val })} 
                                        placeholder="Saisir le texte..." 
                                        style={{ color: id_row_1_bloc_texte_2_texte_1CouleurTexte, opacity: id_row_1_bloc_texte_2_texte_1Opacite }} 
                                    />
                                )}
                                {/* end-id_row_1_bloc_texte_2_texte_1 */}
                            </div>
                            {/* end-id_row_1_bloc_texte_2 */}
                        </div>
                        {/* end-id_row_1 */}
                        {/* id_row_2 */}
                        <div className="row g-0">
                            {/* id_row_2_bloc_texte_1 */}
                            <div className="col-12 col-md-6 col-lg-3">
                                {/* id_row_2_bloc_texte_1_titre_1 */}
                                {id_row_2_bloc_texte_1_titre_1Afficher && (
                                    <RichText 
                                        tagName="h3" 
                                        className="id_row_2_bloc_texte_1_titre_1 " 
                                        value={id_row_2_bloc_texte_1_titre_1Texte} 
                                        onChange={(val) => setAttributes({ id_row_2_bloc_texte_1_titre_1Texte: val })} 
                                        placeholder="Saisir le texte..." 
                                        style={{ color: id_row_2_bloc_texte_1_titre_1CouleurTexte, opacity: id_row_2_bloc_texte_1_titre_1Opacite }} 
                                    />
                                )}
                                {/* end-id_row_2_bloc_texte_1_titre_1 */}
                                {/* id_row_2_bloc_texte_1_texte_1 */}
                                {id_row_2_bloc_texte_1_texte_1Afficher && (
                                    <RichText 
                                        tagName="p" 
                                        className="id_row_2_bloc_texte_1_texte_1 " 
                                        value={id_row_2_bloc_texte_1_texte_1Texte} 
                                        onChange={(val) => setAttributes({ id_row_2_bloc_texte_1_texte_1Texte: val })} 
                                        placeholder="Saisir le texte..." 
                                        style={{ color: id_row_2_bloc_texte_1_texte_1CouleurTexte, opacity: id_row_2_bloc_texte_1_texte_1Opacite }} 
                                    />
                                )}
                                {/* end-id_row_2_bloc_texte_1_texte_1 */}
                            </div>
                            {/* end-id_row_2_bloc_texte_1 */}
                            {/* id_row_2_bloc_image_1 */}
                            <div className="col-12 col-md-6 col-lg-3">
                                {id_row_2_bloc_image_1Afficher && (
                                    <MediaUpload
                                        onSelect={(media) => setAttributes({ id_row_2_bloc_image_1Id: media.id, id_row_2_bloc_image_1Alt: media.alt })}
                                        type="image"
                                        value={id_row_2_bloc_image_1Id}
                                        render={({ open }) => (
                                            <div onClick={open} style={{ cursor: 'pointer' }}>
                                                {id_row_2_bloc_image_1ImageUrl ? (
                                                    <img className="id_row_2_bloc_image_1" src={id_row_2_bloc_image_1ImageUrl} alt={id_row_2_bloc_image_1Alt} style={{ opacity: id_row_2_bloc_image_1Opacite }} />
                                                ) : (
                                                    <Button variant="secondary">Ajouter une image</Button>
                                                )}
                                            </div>
                                        )}
                                    />
                                )}
                            </div>
                            {/* end-id_row_2_bloc_image_1 */}
                            {/* id_row_2_bloc_texte_2 */}
                            <div className="col-12 col-md-6 col-lg-3">
                                {/* id_row_2_bloc_texte_2_titre_1 */}
                                {id_row_2_bloc_texte_2_titre_1Afficher && (
                                    <RichText 
                                        tagName="h3" 
                                        className="id_row_2_bloc_texte_2_titre_1 " 
                                        value={id_row_2_bloc_texte_2_titre_1Texte} 
                                        onChange={(val) => setAttributes({ id_row_2_bloc_texte_2_titre_1Texte: val })} 
                                        placeholder="Saisir le texte..." 
                                        style={{ color: id_row_2_bloc_texte_2_titre_1CouleurTexte, opacity: id_row_2_bloc_texte_2_titre_1Opacite }} 
                                    />
                                )}
                                {/* end-id_row_2_bloc_texte_2_titre_1 */}
                                {/* id_row_2_bloc_texte_2_texte_1 */}
                                {id_row_2_bloc_texte_2_texte_1Afficher && (
                                    <RichText 
                                        tagName="p" 
                                        className="id_row_2_bloc_texte_2_texte_1 " 
                                        value={id_row_2_bloc_texte_2_texte_1Texte} 
                                        onChange={(val) => setAttributes({ id_row_2_bloc_texte_2_texte_1Texte: val })} 
                                        placeholder="Saisir le texte..." 
                                        style={{ color: id_row_2_bloc_texte_2_texte_1CouleurTexte, opacity: id_row_2_bloc_texte_2_texte_1Opacite }} 
                                    />
                                )}
                                {/* end-id_row_2_bloc_texte_2_texte_1 */}
                            </div>
                            {/* end-id_row_2_bloc_texte_2 */}
                            {/* id_row_2_bloc_image_2 */}
                            <div className="col-12 col-md-6 col-lg-3">
                                {id_row_2_bloc_image_2Afficher && (
                                    <MediaUpload
                                        onSelect={(media) => setAttributes({ id_row_2_bloc_image_2Id: media.id, id_row_2_bloc_image_2Alt: media.alt })}
                                        type="image"
                                        value={id_row_2_bloc_image_2Id}
                                        render={({ open }) => (
                                            <div onClick={open} style={{ cursor: 'pointer' }}>
                                                {id_row_2_bloc_image_2ImageUrl ? (
                                                    <img className="id_row_2_bloc_image_2" src={id_row_2_bloc_image_2ImageUrl} alt={id_row_2_bloc_image_2Alt} style={{ opacity: id_row_2_bloc_image_2Opacite }} />
                                                ) : (
                                                    <Button variant="secondary">Ajouter une image</Button>
                                                )}
                                            </div>
                                        )}
                                    />
                                )}
                            </div>
                            {/* end-id_row_2_bloc_image_2 */}
                        </div>
                        {/* end-id_row_2 */}
                        {/* id_row_3 */}
                        <div className="row g-0">
                            {/* id_row_3_bloc_image_1 */}
                            <div className="col-12 col-md-6 col-lg-3">
                                {id_row_3_bloc_image_1Afficher && (
                                    <MediaUpload
                                        onSelect={(media) => setAttributes({ id_row_3_bloc_image_1Id: media.id, id_row_3_bloc_image_1Alt: media.alt })}
                                        type="image"
                                        value={id_row_3_bloc_image_1Id}
                                        render={({ open }) => (
                                            <div onClick={open} style={{ cursor: 'pointer' }}>
                                                {id_row_3_bloc_image_1ImageUrl ? (
                                                    <img className="id_row_3_bloc_image_1" src={id_row_3_bloc_image_1ImageUrl} alt={id_row_3_bloc_image_1Alt} style={{ opacity: id_row_3_bloc_image_1Opacite }} />
                                                ) : (
                                                    <Button variant="secondary">Ajouter une image</Button>
                                                )}
                                            </div>
                                        )}
                                    />
                                )}
                            </div>
                            {/* end-id_row_3_bloc_image_1 */}
                            {/* id_row_3_bloc_texte_1 */}
                            <div className="col-12 col-md-6 col-lg-3">
                                {/* id_row_3_bloc_texte_1_titre_1 */}
                                {id_row_3_bloc_texte_1_titre_1Afficher && (
                                    <RichText 
                                        tagName="h3" 
                                        className="id_row_3_bloc_texte_1_titre_1 " 
                                        value={id_row_3_bloc_texte_1_titre_1Texte} 
                                        onChange={(val) => setAttributes({ id_row_3_bloc_texte_1_titre_1Texte: val })} 
                                        placeholder="Saisir le texte..." 
                                        style={{ color: id_row_3_bloc_texte_1_titre_1CouleurTexte, opacity: id_row_3_bloc_texte_1_titre_1Opacite }} 
                                    />
                                )}
                                {/* end-id_row_3_bloc_texte_1_titre_1 */}
                                {/* id_row_3_bloc_texte_1_texte_1 */}
                                {id_row_3_bloc_texte_1_texte_1Afficher && (
                                    <RichText 
                                        tagName="p" 
                                        className="id_row_3_bloc_texte_1_texte_1 " 
                                        value={id_row_3_bloc_texte_1_texte_1Texte} 
                                        onChange={(val) => setAttributes({ id_row_3_bloc_texte_1_texte_1Texte: val })} 
                                        placeholder="Saisir le texte..." 
                                        style={{ color: id_row_3_bloc_texte_1_texte_1CouleurTexte, opacity: id_row_3_bloc_texte_1_texte_1Opacite }} 
                                    />
                                )}
                                {/* end-id_row_3_bloc_texte_1_texte_1 */}
                            </div>
                            {/* end-id_row_3_bloc_texte_1 */}
                            {/* id_row_3_bloc_image_2 */}
                            <div className="col-12 col-md-6 col-lg-3">
                                {id_row_3_bloc_image_2Afficher && (
                                    <MediaUpload
                                        onSelect={(media) => setAttributes({ id_row_3_bloc_image_2Id: media.id, id_row_3_bloc_image_2Alt: media.alt })}
                                        type="image"
                                        value={id_row_3_bloc_image_2Id}
                                        render={({ open }) => (
                                            <div onClick={open} style={{ cursor: 'pointer' }}>
                                                {id_row_3_bloc_image_2ImageUrl ? (
                                                    <img className="id_row_3_bloc_image_2" src={id_row_3_bloc_image_2ImageUrl} alt={id_row_3_bloc_image_2Alt} style={{ opacity: id_row_3_bloc_image_2Opacite }} />
                                                ) : (
                                                    <Button variant="secondary">Ajouter une image</Button>
                                                )}
                                            </div>
                                        )}
                                    />
                                )}
                            </div>
                            {/* end-id_row_3_bloc_image_2 */}
                            {/* id_row_3_bloc_texte_2 */}
                            <div className="col-12 col-md-6 col-lg-3">
                                {/* id_row_3_bloc_texte_2_titre_1 */}
                                {id_row_3_bloc_texte_2_titre_1Afficher && (
                                    <RichText 
                                        tagName="h3" 
                                        className="id_row_3_bloc_texte_2_titre_1 " 
                                        value={id_row_3_bloc_texte_2_titre_1Texte} 
                                        onChange={(val) => setAttributes({ id_row_3_bloc_texte_2_titre_1Texte: val })} 
                                        placeholder="Saisir le texte..." 
                                        style={{ color: id_row_3_bloc_texte_2_titre_1CouleurTexte, opacity: id_row_3_bloc_texte_2_titre_1Opacite }} 
                                    />
                                )}
                                {/* end-id_row_3_bloc_texte_2_titre_1 */}
                                {/* id_row_3_bloc_texte_2_texte_1 */}
                                {id_row_3_bloc_texte_2_texte_1Afficher && (
                                    <RichText 
                                        tagName="p" 
                                        className="id_row_3_bloc_texte_2_texte_1 " 
                                        value={id_row_3_bloc_texte_2_texte_1Texte} 
                                        onChange={(val) => setAttributes({ id_row_3_bloc_texte_2_texte_1Texte: val })} 
                                        placeholder="Saisir le texte..." 
                                        style={{ color: id_row_3_bloc_texte_2_texte_1CouleurTexte, opacity: id_row_3_bloc_texte_2_texte_1Opacite }} 
                                    />
                                )}
                                {/* end-id_row_3_bloc_texte_2_texte_1 */}
                            </div>
                            {/* end-id_row_3_bloc_texte_2 */}
                        </div>
                        {/* end-id_row_3 */}
                    </div>
                    {/* end-id_inner_block */}
                </div>
                {/* end-id_bloc */}
            </section>
        </>
    );
}